import { defineNuxtPlugin } from "nuxt/app";
import type { Router } from "vue-router";
import { registerGuards } from "@/router/registerGuards";

export default defineNuxtPlugin((nuxtApp) => {
  registerGuards(nuxtApp.$router as Router);
});
